import { render, staticRenderFns } from "./vx.vue?vue&type=template&id=4c6fc994&scoped=true"
import script from "./vx.vue?vue&type=script&lang=js"
export * from "./vx.vue?vue&type=script&lang=js"
import style0 from "./vx.vue?vue&type=style&index=0&id=4c6fc994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6fc994",
  null
  
)

export default component.exports